import { get } from "../base.ehq.model";
import { deserialize } from "../base.serializer";

export const getSuburbs = async (token, baseUrl, params = {}) => {
  const queryPath = `${baseUrl}/suburbs`;

  try {
    const res = await get(token, queryPath, params);
    return deserialize(res);
  } catch (err) {
    throw new Error(err);
  }
};
